function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconLibrary from './IconLibrary';
import IconConfigurator from './IconConfigurator';
import '../css/libstyle.css';
import { libstyle } from './styleParser';

var IconPicker = function (_Component) {
  _inherits(IconPicker, _Component);

  function IconPicker(props) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {};

    if (props.configuredIcon) {
      _this.state.selectedIcon = props.configuredIcon.name;
    }

    _this.onIconSelected = _this.onIconSelected.bind(_this);
    _this.onIconChange = _this.onIconChange.bind(_this);
    _this.onFinishClick = _this.onFinishClick.bind(_this);
    return _this;
  }

  IconPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.configuredIcon && nextProps.configuredIcon.name != this.state.selectedIcon) {
      this.setState({
        selectedIcon: props.configuredIcon.name
      });
    }
  };

  IconPicker.prototype.onIconSelected = function onIconSelected(evt, iconName) {
    this.setState({
      selectedIcon: iconName
    });
  };

  IconPicker.prototype.onIconChange = function onIconChange(currentConfig) {
    this.setState({
      configuredIcon: currentConfig
    });
  };

  IconPicker.prototype.onFinishClick = function onFinishClick() {
    if (this.props.onFinishClick) {
      var result = this.state.configuredIcon;

      if (this.state.configuredIcon === undefined) {
        result = this.props.configuredIcon;
      }

      this.props.onFinishClick(result);
    }
  };

  IconPicker.prototype.render = function render() {
    return React.createElement('div', null, React.createElement('div', {
      className: libstyle.libContainer
    }, React.createElement(IconLibrary, {
      onIconSelected: this.onIconSelected,
      corporateIcons: this.props.corporateIcons
    })), React.createElement('div', {
      className: libstyle.configContainer
    }, React.createElement(IconConfigurator, {
      iconName: this.state.selectedIcon,
      handleIconChange: this.onIconChange,
      configuredIcon: this.props.configuredIcon,
      primaryColor: this.props.primaryColor,
      secondaryColor: this.props.secondaryColor,
      hideSize: this.props.hideSize //hidePreview={true}

    })), React.createElement('button', {
      className: libstyle.libDoneButton,
      type: 'button',
      onClick: this.onFinishClick
    }, 'Done!'));
  };

  return IconPicker;
}(Component);

IconPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  onFinishClick: PropTypes.func.isRequired,
  configuredIcon: PropTypes.object,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  hideSize: PropTypes.bool,
  corporateIcons: PropTypes.array.isRequired
} : {};
export default IconPicker;